import {useStripeConnection} from 'organization/OrganizationSettings/StripeConnectionProvider'
import React from 'react'

import {confirmAlert} from 'react-confirm-alert'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'

export default function PaymentsSettings() {
  const {t} = useI18n()
  const {
    addConnection,
    removeConnection,
    getDashboard,
    stripeConnection,
    loading: stripeLoading,
  } = useStripeConnection()

  const loading = stripeLoading

  const handleRemoveConnection = () => {
    confirmAlert({
      message: t('paymentsSettings.confirmDisconnect'),
      buttons: [
        {
          label: t('paymentsSettings.yes'),
          onClick: async () => {
            removeConnection()
          },
        },
        {
          label: t('paymentsSettings.no'),
          onClick: () => {
            // nothing
          },
        },
      ],
    })
  }

  const handleDashboard = () => {
    getDashboard()
  }

  return (
    <div className="col-12">
      <div className="create__event-area">
        <div className="body__card-wrapper attendant__wrapper">
          <div className="card__header-top">
            <div className="card__title-inner">
              <h4 className="event__information-title">
                {t('paymentsSettings.title')}
              </h4>
            </div>
          </div>
          <div className="setting__main-wrapper pt-25 pb-100">
            <div className="create__event-area mb-20 col-12">
              <div className="body__card-wrapper attendant__wrapper">
                <div className="row">
                  <div className="col-6">
                    <p>
                      <b>{t('paymentsSettings.stripeAccount')}</b>
                    </p>

                    {stripeConnection?.completed_setup && (
                      <div>
                        {t('paymentsSettings.stripeId')}{' '}
                        {stripeConnection.stripe_account_id}
                        <br />
                        {t('paymentsSettings.currency')}{' '}
                        {stripeConnection.default_currency} <br />
                        {t('paymentsSettings.country')}{' '}
                        {stripeConnection.country} <br />
                        {t('paymentsSettings.payoutsActive')}{' '}
                        {stripeConnection.payouts_enabled ? (
                          t('paymentsSettings.yesWord')
                        ) : (
                          <span style={{color: 'red'}}>
                            {t('paymentsSettings.payoutBlocked1')}
                            <br />
                            {t('paymentsSettings.payoutBlocked2')}
                          </span>
                        )}{' '}
                        <br />
                        <StripeDisconnectButton
                          onClick={handleRemoveConnection}
                          disabled={loading}
                        >
                          {t('paymentsSettings.disconnect')}
                        </StripeDisconnectButton>
                      </div>
                    )}
                    {!stripeConnection?.completed_setup && (
                      <div>
                        {t('paymentsSettings.intro1')}
                        <br />
                        <br />
                        {t('paymentsSettings.intro2')}
                      </div>
                    )}
                  </div>

                  {stripeConnection?.completed_setup && (
                    <div className="col-6">
                      <button
                        onClick={handleDashboard}
                        disabled={loading}
                        className={
                          loading
                            ? 'disableBtnStyle w-100 '
                            : 'input__btn w-100'
                        }
                      >
                        {t('paymentsSettings.dashboard')}
                      </button>
                    </div>
                  )}

                  {!stripeConnection?.completed_setup && (
                    <div className="col-6 ">
                      <button
                        onClick={addConnection}
                        disabled={loading}
                        className={
                          loading ? 'disableBtnStyle w-100' : 'input__btn w-100'
                        }
                      >
                        {t('paymentsSettings.continue')}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const StripeDisconnectButton = styled.button`
  text-align: center;
  padding: 0px 20px;
  display: block;
  color: white;
  background: var(--clr-text-secondary);
  margin-top: 15px;
  border-radius: 4px;
`
